import type { FunctionComponent } from 'react';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { VGDisclaimerModal } from '../../../components/VGDisclaimerModal/VGDisclaimerModal';

interface VGDisclaimerModal {
  opened: boolean;
  onClose: () => void;
}

export const SearchLandingPageVGDisclaimerModalWithData: FunctionComponent<VGDisclaimerModal> = ({
  onClose,
}) => {
  const data = useSearchLandingPageBySlugQuery();
  if (!data) return null;

  const vgDisclaimerHtml = data.vgDisclaimerHtml;

  return <VGDisclaimerModal opened onClose={onClose} vgDisclaimerHtml={vgDisclaimerHtml} />;
};
